import React, { useEffect, useState } from 'react'
import { withRouter, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Button, Divider, message } from 'antd'
import { getUser } from '../../../reducers'
import FormWorkOrder from '../../containers/FormWorkOrder'
import './newWorkStyles.css'
import { cloudFunctions } from '../../../config/Fire'

const NewWork = props => {
    const [savingWorkOrder, setSavingWorkOrder] = useState(false)

    const saveWorkOrder = workOrder => {
        setSavingWorkOrder(true)
        console.log(workOrder);
        cloudFunctions.newWorkOrder(workOrder)
            .then(response => {
                setSavingWorkOrder(false)
                if (response.data && response.data.code !== undefined && response.data.code === 0 && response.data.workOrder !== undefined) {
                    message.success('¡La orden de trabajo se guardó exitósamente!')
                    props.onBack(true, response.data.workOrder)
                } else {
                    console.log(response)
                    message.error('Se produjo un error al guardar la orden de trabajo. Por favor, vuelva a intentarlo')
                }
            })
            .catch(err => {
                setSavingWorkOrder(false)
                console.log(err)
                message.error('Se produjo un error al guardar la orden de trabajo. Por favor, vuelva a intentarlo')
            })
    }

    return (
        <Grid className="newWorkCont">
            <Row center="xs">
                <Col xs={12}>
                    <h2>Nueva orden de trabajo</h2>
                </Col>
            </Row>
            <Divider/>
            <Row center="xs">
                <Col xs={12}>
                    <FormWorkOrder employees={props.employees} clients={props.clients} onSubmitWorkOrder={saveWorkOrder}
                        isEditing={false}
                        loading={savingWorkOrder}/>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={6}>
                    <Button onClick={() => props.onBack(false)} disabled={savingWorkOrder} loading={savingWorkOrder}>
                        Salir
                    </Button>
                </Col>
            </Row>
        </Grid>
    )
}

NewWork.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(NewWork))
